/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

export const importMap = {
  cs: () => import('state/translations/cs.json'),
  de: () => import('state/translations/de.json'),
  en: () => import('state/translations/en.json'),
  es: () => import('state/translations/es.json'),
  fr: () => import('state/translations/fr.json'),
  it: () => import('state/translations/it.json'),
  ko: () => import('state/translations/ko.json'),
  nl: () => import('state/translations/nl.json'),
  pl: () => import('state/translations/pl.json'),
  pt: () => import('state/translations/pt.json'),
  ro: () => import('state/translations/ro.json'),
  ca_ES: () => import('state/translations/ca_ES.json'),
  cs_CZ: () => import('state/translations/cs_CZ.json'),
  de_AQ: () => import('state/translations/de_AQ.json'),
  de_AT: () => import('state/translations/de_AT.json'),
  de_CH: () => import('state/translations/de_CH.json'),
  de_DE: () => import('state/translations/de_DE.json'),
  en_AQ: () => import('state/translations/en_AQ.json'),
  en_AT: () => import('state/translations/en_AT.json'),
  en_CA: () => import('state/translations/en_CA.json'),
  en_CH: () => import('state/translations/en_CH.json'),
  en_CZ: () => import('state/translations/en_CZ.json'),
  en_DE: () => import('state/translations/en_DE.json'),
  en_ES: () => import('state/translations/en_ES.json'),
  en_FR: () => import('state/translations/en_FR.json'),
  en_GB: () => import('state/translations/en_GB.json'),
  en_ID: () => import('state/translations/en_ID.json'),
  en_JA: () => import('state/translations/en_JA.json'),
  en_KR: () => import('state/translations/en_KR.json'),
  en_MY: () => import('state/translations/en_MY.json'),
  en_NL: () => import('state/translations/en_NL.json'),
  en_NZ: () => import('state/translations/en_NZ.json'),
  en_PL: () => import('state/translations/en_PL.json'),
  en_PT: () => import('state/translations/en_PT.json'),
  en_RO: () => import('state/translations/en_RO.json'),
  en_SG: () => import('state/translations/en_SG.json'),
  en_TH: () => import('state/translations/en_TH.json'),
  en_TW: () => import('state/translations/en_TW.json'),
  en_US: () => import('state/translations/en.json'),
  en_ZA: () => import('state/translations/en_ZA.json'),
  es_AQ: () => import('state/translations/es_AQ.json'),
  es_ES: () => import('state/translations/es_ES.json'),
  es_PT: () => import('state/translations/es_PT.json'),
  eu_ES: () => import('state/translations/eu_ES.json'),
  fr_AQ: () => import('state/translations/fr_AQ.json'),
  fr_CA: () => import('state/translations/fr_CA.json'),
  fr_CH: () => import('state/translations/fr_CH.json'),
  fr_FR: () => import('state/translations/fr_FR.json'),
  gl_ES: () => import('state/translations/gl_ES.json'),
  hak_TW: () => import('state/translations/hak_TW.json'),
  id_ID: () => import('state/translations/id_ID.json'),
  it_AQ: () => import('state/translations/it_AQ.json'),
  it_CH: () => import('state/translations/it_CH.json'),
  ja_JA: () => import('state/translations/ja_JA.json'),
  jv_ID: () => import('state/translations/jv_ID.json'),
  ko_KR: () => import('state/translations/ko_KR.json'),
  ml_MY: () => import('state/translations/ml_MY.json'),
  ms_MY: () => import('state/translations/ms_MY.json'),
  ms_SG: () => import('state/translations/ms_SG.json'),
  nan_TW: () => import('state/translations/nan_TW.json'),
  nl_ID: () => import('state/translations/nl_ID.json'),
  nl_NL: () => import('state/translations/nl_NL.json'),
  pa_MY: () => import('state/translations/pa_MY.json'),
  pl_PL: () => import('state/translations/pl_PL.json'),
  pt_ES: () => import('state/translations/pt_ES.json'),
  pt_PT: () => import('state/translations/pt_PT.json'),
  ro_RO: () => import('state/translations/ro_RO.json'),
  ta_MY: () => import('state/translations/ta_MY.json'),
  ta_SG: () => import('state/translations/ta_SG.json'),
  te_MY: () => import('state/translations/te_MY.json'),
  th_MY: () => import('state/translations/th_MY.json'),
  th_TH: () => import('state/translations/th_TH.json'),
  zh_MY: () => import('state/translations/zh_MY.json'),
  zh_SG: () => import('state/translations/zh_SG.json'),
  zh_TW: () => import('state/translations/zh_TW.json'),
};
